export default {
    success: 'Your request has been sent successfully.',
    label: {
        title: 'Request',
        email: 'E-Mail *',
        message: 'Message *',
        notice: 'Fields marked with an asterisk (*) are required.',
        action: 'Send'
    },
    error: {
        name: {
            required: 'Please enter your name'
        },
        email: {
            required: 'Please enter your e-mail address',
            email: 'Please make sure you have a correct e-mail address'
        },
        subject: {
            required: 'Please enter the subject'
        },
        message: {
            required: 'Please enter the message'
        }
    }
}
